import type { ReactNode } from "react";

interface RevealProps {
  children: ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  as?: "div" | "section" | "article" | "li" | "header";
}

/**
 * Content wrapper kept intentionally free of scroll-triggered opacity effects.
 * Essential content must always render at full opacity (accessibility + no
 * dependency on IntersectionObserver). Kept as a component so existing call
 * sites and layout classes stay unchanged.
 */
export function Reveal({ children, className, as = "div" }: RevealProps) {
  const Tag = as as keyof JSX.IntrinsicElements;
  return <Tag className={className}>{children}</Tag>;
}

/** Wrapper that renders children in a simple container at full opacity. */
export function RevealGroup({
  children,
  className,
}: {
  children: ReactNode[];
  className?: string;
  stagger?: number;
}) {
  return (
    <div className={className}>
      {children.map((child, i) => (
        <div key={i}>{child}</div>
      ))}
    </div>
  );
}
